import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 rounded-xl font-medium tracking-wide transition-all duration-300';
  const variants = {
    primary: 'bg-sage text-white hover:bg-sage/90 shadow-lg shadow-sage/20 hover:shadow-xl hover:shadow-sage/30',
    outline: 'border-2 border-gold text-charcoal hover:bg-gold/10'
  };
  const width = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${width} ${className}`} {...props} data-id="element-26">
      {children}
    </motion.button>;
}